export const CART_INFO = 'CART_INFO';
export const BOOKING_STEP = 'BOOKING_STEP';
export const SET_DATA_BY_STEP = 'SET_DATA_BY_STEP';
export const SET_LOADING = 'SET_LOADING';

export function setCart(Cart) {
  return {
    type: CART_INFO,
    payload: Cart
  }
}

export function setBookingStep(step) {
  return {
    type: 'BOOKING_STEP',
    payload: step
  }
}

export function setDataByStep(step, data) {
  return {
    type: 'SET_DATA_BY_STEP',
    payload: { [step]: data }
  }
}

export function setLoading(loading) {
  return {
    type: 'SET_LOADING',
    payload: loading 
  }
}